// extracted by mini-css-extract-plugin
module.exports = {"conditions":"bf_d3","conditions__content":"bf_d4","conditions__footer":"bf_d5"};